module.exports = __webpack_public_path__ + "img/indu_active_8.6049fe87.png";